export enum ELocalesFormats {
    FR = 'fr-FR',
}
